module.exports = __webpack_public_path__ + "static/better-employee-elizabeth-350w-a547d6dd7850ef2e6ea936c1a0c3e599.jpg";